import { MyCircularProgress } from "../MyCircularProgress"
import { Column } from "../../style"
import { BadQuality } from "../SvgComponents/Icons/BadQuality"
import { GuestCheck, GuestCheck3 } from "../SvgComponents/Icons/GuestCheck"

interface IBiometricsStatusProps {
    loadingMathImages: boolean
    valid: boolean
    score: number
}

const BiometricsStatus = ({
    loadingMathImages,
    valid,
    score
}: IBiometricsStatusProps) => {
    return (
        <div
        >
            <div
                style={{
                    fontWeight: "bold",
                    fontSize: 14,
                    flexDirection: "row",
                    display: "flex",
                    alignItems: "center",
                    gap: 10,
                    position: "relative",
                    justifyContent: "end",
                    flex: 1,
                }}
            >
                {loadingMathImages && (
                    <>
                        <div style={{ fontWeight: 600 }}>
                            Verificação de biometria em andamento
                        </div>
                        <MyCircularProgress color="#7041ff" size={30} />
                    </>
                )}
                {!loadingMathImages && (
                    <>
                        <Column>
                            <div style={{ fontWeight: 600 }}>Verificação da biometria</div>
                            <div style={{ fontSize: 13, marginTop: -5, fontWeight: 400 }}>Score: {score}%</div>
                        </Column>
                        {valid && (
                            <GuestCheck3 size={26} />
                        )}
                        {!valid && (
                            <BadQuality size={26} />
                        )}
                    </>
                )}

            </div>
        </div>
    )
}

export default BiometricsStatus